import React from "react";
import { useHistory } from "react-router-dom";
import * as S from "./styles";
import { IRegional } from "interfaces/regional";
import { useTranslation, usePermissions } from "hooks";
import { translations } from "./translations";

interface IGridCarriersProps {
  regionals: IRegional[] | Record<string, any>[];
}

interface ItemProps {
  regional: IRegional | Record<string, any>;
}

const Item: React.FC<ItemProps> = ({ regional }) => {
  const history = useHistory();
  const { checkUserPermission } = usePermissions();
  const havePermission = checkUserPermission("editRegional");
  return (
    <S.ItemContainer
      onClick={() =>
        havePermission && history.push(`/settings/regional/${regional.id}`)
      }
    >
      <S.ItemContent pointer={havePermission}>
        <S.ItemValue>{regional.code_regional}</S.ItemValue>
        <S.ItemValue>{regional.name}</S.ItemValue>

        {havePermission && (
          <S.ButtonDetail>
            <S.IconDetail />
          </S.ButtonDetail>
        )}
      </S.ItemContent>
    </S.ItemContainer>
  );
};

export const GridRegional: React.FC<IGridCarriersProps> = ({
  regionals = [],
}) => {
  const { getTranslation } = useTranslation(translations);
  return (
    <S.Container>
      <S.Header>
        <S.Label>{getTranslation("codRegional")}</S.Label>
        <S.Label>{getTranslation("nome")}</S.Label>
      </S.Header>
      {regionals.length > 0 &&
        regionals.map((regional) => (
          <Item regional={regional} key={regional.id} />
        ))}
    </S.Container>
  );
};
